import { render, staticRenderFns } from "./mnewsList.vue?vue&type=template&id=799e7d88&scoped=true&"
import script from "./mnewsList.vue?vue&type=script&lang=js&"
export * from "./mnewsList.vue?vue&type=script&lang=js&"
import style0 from "./mnewsList.vue?vue&type=style&index=0&id=799e7d88&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799e7d88",
  null
  
)

export default component.exports